export default __webpack_public_path__ + "static/2_37-02a2c1e86005e40ba02559f440ac0ca0.png";